//import ImagePerson from "@/components/functionals/ImagePerson.vue";
import CellDateTime from "@/components/functionals/DatetimeFormatter.vue";
import ColorType from "@/components/functionals/ColorType.vue";
import HoverPopoverMessageFormatter from "@/components/functionals/HoverPopoverMessageFormatter.vue";
//import { formatterMoney } from "@/utils";
//import InteractionTypeTagFormatter from "@/components/functionals/InteractionTypeTagFormatter.vue";

export const SwitcherColumns = [
  {
    prop: "ServiceName",
    name: "ServiceName",
    label: "Nombre del servicio",
    width: 200,
    align: "center",
    fixed: true,
    sortable: true
  },
  {
    prop: "CreateAt",
    name: "CreateAt",
    label: "Fecha de creacion",
    minWidth: 180,
    sortable: true,
    formatter: CellDateTime
  },
  {
    prop: "Actived",
    name: "Actived",
    label: "Estado",
    align: "center",
    width: 150,
    formatter: ColorType
  },
  {
    prop: "InactiveAt",
    name: "InactiveAt",
    label: "Fecha de Inactivacion",
    minWidth: 190,
    sortable: true,
    formatter: CellDateTime
  },
  {
    prop: "InactivatedByName",
    name: "InactivatedByName",
    label: "Inactivado por:",
    width: 200,
    align: "center",
    sortable: true,
    formatter: (r) => (r.Actived == true ? r.InactivatedByName : "")
  },
  {
    prop: "MessageTerminal",
    name: "MessageTerminal",
    label: "Mensage de Terminal",
    minWidth: 300,
    formatter: HoverPopoverMessageFormatter
  },
  {
    prop: "Reason",
    name: "Reason",
    label: "Razon de Inactivacion",
    minWidth: 300,
    formatter: HoverPopoverMessageFormatter
  },
  {
    prop: "ReactivatedAt",
    name: "ReactivatedAt",
    label: "Fecha de Reactivacion",
    minWidth: 190,
    sortable: true,
    formatter: CellDateTime
  },
  {
    prop: "InactivatedByName",
    name: "InactivatedByName",
    label: "Reactivado por:",
    width: 200,
    align: "center",
    sortable: true,
    formatter: (r) => (r.Actived == false ? r.InactivatedByName : "")
  }
];
/*
function changeLabel(r) {
  console.log("hola changeLabel")
   let label = r.Actived == true? "Reactivado por: ": "Inactivado por:"
   console.log(label, typeof label)
   return label
}
*/
export const SwitcherActions = [
  {
    icon: "el-icon-video-play",
    label: "Activar Servicio",
    command: "activate",
    condition: (r) => r.Actived === true //{console.log("maldita r: ", r)}
  },
  {
    icon: "el-icon-video-pause",
    label: "Inactivar servicio",
    command: "inactivate",
    condition: (r) => r.Actived === false
  }
];
